import styled from 'styled-components';

export const Option = styled.li<{ disabled?: boolean }>`
  padding: 0 1rem;
  font-size: 0.9rem;
  cursor: pointer;
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.colors.lightestGray : undefined};

  .checkbox {
    padding: 1rem 0;
  }
`;

export const Options = styled.ul<{ disabled?: boolean }>`
  position: absolute;
  box-sizing: border-box;
  width: calc(100% - 2px);
  margin: 0 1px;
  padding: 0;
  z-index: 10;
  max-height: 20rem;
  overflow-y: auto;

  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  list-style-type: none;

  &:hover > ${Option} {
    background-color: ${({ disabled }) => (disabled ? null : 'transparent')};
  }

  &:hover > ${Option}:hover {
    background-color: ${({ theme, disabled }) =>
      disabled ? null : theme.colors.lightGrey};
  }
`;
